import { useState, useEffect } from 'react';
import HeaderWeb from './componets/headerwebsite/headerweb';
import FooterWeb from './componets/footerwebsite/footerweb';
import Homepagebanner from './homeBanner/homepagebanner';
import Categorymanagement from './categoryManagement/categorymanagement';
import Productmanagement from './productmanagement/productmanagement';

import './indexpage.css'; // Import the CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import VideoManagement from './videoManagement/videomanagement';

function HomePage() {
  const [showScroll, setShowScroll] = useState(false);

  // Show the button when scrolling down
  useEffect(() => {
    const checkScrollTop = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  // Scroll to the top when clicking the button
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {/* Scroll to Top Button */}
      {showScroll && (
        <button className="scroll-top-button" onClick={scrollToTop}>
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      )}
      <HeaderWeb />
      <div>
        <Homepagebanner />
      </div>
      <div>
        <Categorymanagement />
      </div>
      <div>
        <Productmanagement />
      </div>
      <div>
        <VideoManagement />
      </div>
      <FooterWeb />


    </div>
  );
}

export default HomePage;
